import { styled, TableCell, tableCellClasses } from "@mui/material";
import { getColors } from "utils";

const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "maxWidth" && prop !== "padding",
})(({ theme, maxWidth, padding }) => {
  const colors = getColors(theme, "");
  const { lighter } = colors;

  const getPadding = (padding) => {
    if (padding === "none") {
      return "13px 0px";
    } else if (padding === "checkbox") {
      return "13px 0px";
    } else if (padding === "normal") {
      return "13px 20px";
    } else {
      return "13px 20px";
    }
  };

  return {
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: lighter,
      color: colors[600],
      padding: getPadding(padding),
      // padding: "13px 24px",
      zIndex: 12,
      ...(!!padding && padding === 'checkbox' && { width: 50 }),
    },
    [`&.${tableCellClasses.body}`]: {
      ...(!!padding && padding === 'checkbox' && { width: 50 }),
      fontSize: 14,
      height: 72,
      // padding: "26px 24px",
      padding: getPadding(padding),
      // padding: "0 24px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: maxWidth ?? 250,
      cursor: "default",
      color: theme.palette.text.secondary,
    },
    [`&.${tableCellClasses.footer}`]: {
      backgroundColor: "#ffffff",
      color: colors[600],
      padding: "10px 15px",
      position: "sticky",
      bottom: -1,
      borderTop: "1px solid #dcdee0",
      borderBottom: "0px solid #dcdee0",
      zIndex: 12,
    },
  };
});

export default StyledTableCell;
